import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Text from '$tablet-app/src/app/components/Text';
import MiniCompletionCircle from '$tablet-app/src/app/goals/components/MiniCompletionCircle';
import {
  getGoalCompletionProgress,
  getGoalFrequencyDisplayText,
  getGoalProgressPercentage,
} from '$tablet-app/src/app/goals/functions';
import { useIncrementGoal } from '$tablet-app/src/app/goals/hooks/useIncrementGoal';
import { Alert } from '$tablet-app/src/app/models';
import { useCurrentUser } from '$tablet-app/src/app/users';
import { getStartDate } from '@akin-home/calendar';
import { useGetGoal } from '@akin-home/goals/frontend';
import { spacing } from '@akin-home/theme';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { ItemStyling } from './types';

interface Props {
  item: Alert;
  goal_id: string;
  styling: ItemStyling;
}

/** Item to be displayed in the breakdown schedule */
const GoalReminderScheduleItemContent: FC<Props> = (props) => {
  const { item, goal_id, styling } = props;

  const date = getStartDate(item);

  const profile = useCurrentUser();
  const { goal } = useGetGoal(goal_id);

  const goal_key = {
    user_id: profile.id,
    date,
  };

  const increment = useIncrementGoal(goal_key);

  const onPressIncrementGoal = () => {
    goal && increment(goal);
  };

  const completion_progress = goal
    ? getGoalCompletionProgress(goal, {
        user_id: profile.id,
        date,
      })
    : undefined;

  return (
    <View style={styles.container}>
      {goal ? (
        <View style={styling.imageContainerStyle}>
          <MiniCompletionCircle
            emoji={goal.emoji}
            diameter={styling.emojiSize}
            progress={getGoalProgressPercentage(goal, goal_key)}
          />
        </View>
      ) : null}

      <View style={[styles.contentContainer, styling.contentContainerStyle]}>
        <View style={styles.textContainer}>
          <Text
            variant={styling.titleTextVariant}
            weight="semibold"
            numberOfLines={2}
            style={[styles.titleText, styling.titleTextStyle]}
          >
            {item.title}
          </Text>

          {goal ? (
            <Text variant={styling.subtitleTextVariant}>
              {getGoalFrequencyDisplayText(goal)}
            </Text>
          ) : null}
        </View>

        <NewButton variant="secondary" onPress={onPressIncrementGoal}>
          <Text>
            Done {goal ? completion_progress : null}/
            {goal?.completions_per_period}
          </Text>
        </NewButton>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[4],
  },
  contentContainer: {
    flex: 1,
    gap: spacing[2],
  },
  textContainer: {
    flex: 1,
  },
  titleText: {
    overflow: 'hidden',
  },
});

export default GoalReminderScheduleItemContent;
